import { validationSchemaCreateUser } from 'containers/AccountPage/components/schemas'
import { useMetadataUser } from 'contexts/metadata-user-context'
import { useFormik } from 'formik'
import toast from 'react-hot-toast'
import { registerUser } from 'services/register-user'

type Props = {
  setIsOpenModal: (isOpen: boolean) => void
}

export const UserRegistrationModal = ({ setIsOpenModal }: Props) => {
  const { profile } = useMetadataUser()

  const formik = useFormik<DtoUserCreate>({
    initialValues: {
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: validationSchemaCreateUser,
    onSubmit: (values) => {
      const body = {
        name: values.name,
        email: values.email,
        password: values.password,
        company_id: profile?.company.id,
      }

      toast
        .promise(registerUser(body), {
          loading: 'Salvando...',
          success: 'Usuário cadastrado com sucesso',
          error: 'Erro ao cadastrar usuário',
        })
        .then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        })
        .catch((error) => {
          toast.error(error?.message ?? 'Erro ao cadastrar usuário')
        })
    },
  })

  const inputs_fields = [
    {
      name: 'name',
      label: 'Nome',
      type: 'text',
      placeholder: 'Nome',
    },
    {
      name: 'email',
      label: 'E-mail',
      type: 'email',
      placeholder: 'example@example.com',
    },
    {
      name: 'password',
      label: 'Senha',
      type: 'password',
      placeholder: 'Senha',
    },
    {
      name: 'confirmPassword',
      label: 'Confirmar senha',
      type: 'password',
      placeholder: 'Confirmar senha',
    },
  ]

  const handleError = <T extends DtoUserCreate>(
    fieldName: keyof T,
    formik: any,
  ) => {
    if (formik.touched[fieldName] && Boolean(formik.errors[fieldName])) {
      return `mt-1 border border-red-500 focus:ring-2 focus:outline-none focus:ring-red-500 focus:border-red-500`
    }
    return `mt-1 border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent`
  }

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 `}
    >
      <div className="bg-white dark:bg-neutral-800 p-5 rounded-lg w-full max-w-lg">
        <h2 className="text-2xl font-semibold text-neutral-900 dark:text-neutral-100 text-center mb-2">
          Cadastro de usuário
        </h2>

        <form className="w-full" onSubmit={formik.handleSubmit}>
          {inputs_fields.map((input, index) => (
            <div key={`${input.name}.${index}`} className={`w-full mt-5`}>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-neutral-900 dark:text-neutral-300"
                >
                  {input.label}
                </label>
                <input
                  type={input.type}
                  name={input.name}
                  id={input.name}
                  placeholder={input.placeholder}
                  onChange={formik.handleChange}
                  value={formik.values[input.name as keyof DtoUserCreate]}
                  className={`${handleError(input.name as keyof DtoUserCreate, formik)} block w-full mt-2 px-3 py-2.5 border-neutral-300 dark:border-neutral-700 rounded-full shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent`}
                />

                {input.type === 'password' && input.name === 'password' && (
                  <p className="text-xs text-neutral-500 dark:text-neutral-400 my-1">
                    A senha deve conter pelo menos uma letra maiúscula, uma
                    letra minúscula e um número
                  </p>
                )}

                {formik.touched[input.name as keyof DtoUserCreate] &&
                  Boolean(formik.errors[input.name as keyof DtoUserCreate]) && (
                    <p className="text-red-500 text-sm">
                      {formik.errors[input.name as keyof DtoUserCreate]}
                    </p>
                  )}
              </div>
            </div>
          ))}

          <div className="flex w-full md:items-center space-x-4 justify-end mt-8">
            <button
              type="button"
              className={`
                bg-white border-2 dark:bg-neutral-700
                hover:dark:bg-neutral-700/60 transition-colors duration-500
                ease-in-out text-neutral-900 dark:text-neutral-200 px-6
                py-2 rounded-full disabled:cursor-not-allowed disabled:bg-neutral-200
                disabled:hover:bg-neutral-200 dark:disabled:bg-neutral-700
                dark:disabled:hover:bg-neutral-700
              `}
              onClick={() => {
                setIsOpenModal(false)
              }}
              disabled={formik.isSubmitting}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={`
                bg-[#4F46E5] hover:bg-[#4F46E5]/80 hover:dark:bg-[#4F46E5]/60
                transition-colors duration-500 ease-in-out text-white
                px-6 py-2 rounded-full disabled:cursor-not-allowed disabled:bg-[#8580d8]
                disabled:hover:bg-[#8e89dd] dark:disabled:bg-[#4F46E5]
              `}
              disabled={formik.isSubmitting}
            >
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
